import './styles.css';

import { cn } from '@/lib/utils';

import { Colors } from '@/styles/types';

export const colorByVariant: Partial<{ [x in Colors]: string }> = {
  'tertiary-500': '[--spinner-color:var(--color-tertiary-500)]',
  'base-white': '[--spinner-color:var(--color-base-white)]',
  'base-black': '[--spinner-color:var(--color-base-black)]',
  'gray-200': '[--spinner-color:var(--color-gray-200)]',
  'gray-500': '[--spinner-color:var(--color-gray-500)]',
  'gray-700': '[--spinner-color:var(--color-gray-700)]',
  'brand-500': '[--spinner-color:var(--color-brand-500)]',
} as const;

export const Spinner = ({
  className,
  color = 'tertiary-500',
}: {
  className?: string;
  color?: keyof typeof colorByVariant;
}) => {
  return (
    <div
      className={cn(
        'loading-spinner h-4 w-4 animate-spin rounded-full',
        colorByVariant[color],
        className
      )}
    />
  );
};
